/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Update_IdInputs */

const en_mobile_ota_update_id = /** @type {(inputs: Mobile_Ota_Update_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update ID`)
};

const es_mobile_ota_update_id = /** @type {(inputs: Mobile_Ota_Update_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de actualización`)
};

/**
* | output |
* | --- |
* | "Update ID" |
*
* @param {Mobile_Ota_Update_IdInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_update_id = /** @type {((inputs?: Mobile_Ota_Update_IdInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Update_IdInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_update_id(inputs)
	return en_mobile_ota_update_id(inputs)
});